module.exports = __webpack_public_path__ + "static/media/forward-arrow-light.32fd7fc8.svg";